import { Controller, useFormContext } from "react-hook-form";
import { CreateCompanyFormDataType } from "../../../../stores/types/companyTypes.tsx";
import { RevCheckbox, RevInput } from "@revmatics/catalyst";
import { domainRegex } from "../../../../helpers/functions/hasValidHelpers.ts";
import { useAppSelector } from "../../../../stores/hooks/hooks.ts";

export const StepCompanyAndBrandDetails = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<CreateCompanyFormDataType>();
  const errorCreateCompany = useAppSelector(
    (state) => state.company.errorCreateCompany,
  );

  return (
    <div className="space-y-6">
      <div>
        <p className="typography-body-bold-sm">Company Information</p>
        <p className="typography-body-xs text-monochrome-600">
          Basic company details and branding information.
        </p>
        <div className="mt-4 mb-1 space-y-4">
          <RevInput
            name="company_name"
            className="w-full"
            label="Company Name"
            placeholder=""
            type="text"
            size="md"
            required
            register={register("company_name", {
              required: "Company name is required.",
            })}
            error={errors.company_name || errorCreateCompany || undefined}
          />
        </div>
      </div>
      <div>
        <p className="typography-body-bold-sm">Brand Information</p>
        <p className="typography-body-xs text-monochrome-600">
          Pricing is determined by the number of brands. If editing, please
          ensure contract includes the purchase of multiple brands.
        </p>
        <div className="mt-4 rounded-lg border border-monochrome-200 p-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
          <RevInput
            name="brand_name"
            className="w-full"
            label="Brand Name"
            type="text"
            size="md"
            required
            register={register("brand_name", {
              required: "Brand name is required.",
            })}
            error={errors.brand_name}
          />
          <RevInput
            name="brand_website"
            className="w-full"
            label="Brand Website"
            type="text"
            size="md"
            required
            register={register("brand_website", {
              required: "Brand website is required.",
              pattern: {
                value: domainRegex,
                message: "Invalid website",
              },
            })}
            error={errors.brand_website}
          />

          <div className="lg:col-span-2 mt-2">
            <Controller
              name="enable_quickstart"
              control={control}
              render={({ field: { value, onChange } }) => (
                <RevCheckbox
                  label="Enable Onboarding?"
                  checked={value}
                  handleChecked={() => onChange(!value)}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
